import AddIcon from '@mui/icons-material/Add';
import { Box, Fab } from '@mui/material';
import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { TagDto } from '../../common/PricePrgClient';
import { RootState } from '../../store';
import { getAllTags } from './redux/tagSlices';
import { TagRow } from './TagRow';

const mapStateToProps = (state: RootState) => ({
    tags: state.tags.tags
});
type Props = ReturnType<typeof mapStateToProps>;
export const Tags = ({ tags }: Props) => {
    const dispatch = useDispatch();

    const [tagArray, setTagArray] = useState([] as TagDto[]);
    useEffect(() => {
        dispatch(getAllTags.request());
    }, [dispatch]);

    useEffect(() => {
        setTagArray(Object.values(tags));
    }, [tags]);

    const addNewTag = () => {
        setTagArray([...tagArray, { name: '', tagId: 0, shortName: '', color: 'transparent' }]);
    };
    return (
        <>
            <Box sx={{ flexDirection: 'column' }}>
                <>
                    {tagArray.map(p => (
                        <TagRow key={p.tagId} tag={p} />
                    ))}
                    <Fab color="secondary" size="small" onClick={addNewTag}>
                        <AddIcon />
                    </Fab>
                </>
            </Box>
        </>
    );
};

export default connect(mapStateToProps)(Tags);
